/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {fetchData, getEncryptedRoute, toasterrormsg, useMenuIdPermissions} from '../../../reusable'
import {Tr} from '../../../_metronic/i18n/Tr'

interface AddSpaceHeaderProps {
  spacerentalId: string // Assuming spacerentalId is of type string, adjust as needed
}
const AddSpaceHeader: React.FC<AddSpaceHeaderProps> = ({spacerentalId}) => {
  let t = Tr()
  const {menuId, menuIdEdit} = useMenuIdPermissions()

  const location = useLocation()
  const editSpacerentalId = (location.state as any)?.spacerentalId || ''
  const [spaceRenatalDetails, setSpacerentalDetails] = useState([])

  // space Details api call
  const spaceDetailsApiCall = async () => {
    var param: any = {
      spacerentalId: String(editSpacerentalId),
    }
    var response: any = await fetchData('vendor/public/spaceDetails', param)

    if (response.status == '200') {
      setSpacerentalDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editSpacerentalId != '') {
      spaceDetailsApiCall()
    }
  }, [])

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['basicInfo'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['basicInfo']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacebasicinfo/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['basicInfo']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addspacebasicinfo/', {menuId:menuId})}
                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Basic Info')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['basicInfo']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacebasicinfo/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['basicInfo']
                              ? 'active_tab  text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Basic Info')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['location'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['location']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacelocation/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['location']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addspacelocation/', {menuId:menuId})}
                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Location')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['location']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacelocation/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['location']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Location')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['propertyDetail'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['propertyDetail']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacedetails/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['propertyDetail']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addspacedetails/', {menuId:menuId})}
                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Property Details')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['propertyDetail']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacedetails/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['propertyDetail']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Property Details')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['rentableSpace'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['rentableSpace']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/viewrentablespaces/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['rentableSpace']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../viewrentablespaces/', {menuId:menuId})}
                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Space Options')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['rentableSpace']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/viewrentablespaces/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['rentableSpace']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Space Options')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['photos'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['photos']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacephotos/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['photos']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addspacephotos/', {menuId:menuId})}
                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Photos')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['photos']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacephotos/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['photos']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Photos')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacefacilities/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addspacefacilities/', {menuId:menuId})}
                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Facilities & Services')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacefacilities/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Facilities & Services')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['availability'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['availability']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspaceavailability/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['availability']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addspaceavailability/', {menuId:menuId})}
                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Availability')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['availability']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspaceavailability/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['availability']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Availability')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['policies'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['policies']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacepolicies/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['policies']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addspacepolicies/', {menuId:menuId})}
                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Policies')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['policies']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacepolicies/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['policies']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Policies')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {spaceRenatalDetails &&
                spaceRenatalDetails.length > 0 &&
                spaceRenatalDetails[0]['completedSteps'] &&
                spaceRenatalDetails[0]['completedSteps']['financeAndLegal'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['financeAndLegal']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacefinance/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['financeAndLegal']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}

                    to={getEncryptedRoute('../addspacefinance/', {menuId:menuId})}

                    state={{spacerentalId: editSpacerentalId}}
                  >
                    {t('Finance & Legal')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      spaceRenatalDetails &&
                      spaceRenatalDetails.length > 0 &&
                      spaceRenatalDetails[0]['completedSteps'] &&
                      spaceRenatalDetails[0]['completedSteps']['financeAndLegal']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addspacefinance/'
                        ? `${
                            spaceRenatalDetails &&
                            spaceRenatalDetails.length > 0 &&
                            spaceRenatalDetails[0]['completedSteps'] &&
                            spaceRenatalDetails[0]['completedSteps']['financeAndLegal']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Finance & Legal')}
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export {AddSpaceHeader}
